import React, { ReactElement, useState } from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  &.animate-active {
    transition: opacity 0.7s;
    opacity: 0;
  }
  &.animate-loaded {
    opacity: 1;
  }
`

interface IAnimateProps {
  children: ReactElement
  isAnimated?: boolean
}
export default function Animate(props: IAnimateProps): ReactElement {
  const { children, isAnimated } = props
  const [loaded, setLoaded] = useState(false)

  // if page loads instantly, add short delay to ensure smoothness
  if (document.readyState === 'complete') {
    setTimeout(() => {
      setLoaded(true)
    }, 500)
  }
  // else addEventListener to wait for load
  window.addEventListener('load', () => setLoaded(true))

  const loadedClass = loaded ? 'animate-loaded' : ''
  const animateClass = isAnimated ? 'animate-active' : ''

  return (
    <Styles className={`${animateClass} ${loadedClass}`}>{children}</Styles>
  )
}
